import { render, staticRenderFns } from "./EndoscopeBrandArchive.vue?vue&type=template&id=2aea5fb4&scoped=true"
import script from "./EndoscopeBrandArchive.vue?vue&type=script&lang=js"
export * from "./EndoscopeBrandArchive.vue?vue&type=script&lang=js"
import style0 from "./EndoscopeBrandArchive.vue?vue&type=style&index=0&id=2aea5fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea5fb4",
  null
  
)

export default component.exports